import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { recordPageVisit } from '../api/api';

export default function PageVisitTracker({ userId }) {
  const { pathname } = useLocation();
  const lastVisit = useRef(null);
  useEffect(() => {
    if (userId == null) return;
    const key = `${userId}:${pathname}`;
    if (lastVisit.current === key) return;
    lastVisit.current = key;
    // Query/filter changes and data polling are not new page visits.
    recordPageVisit(pathname).catch(() => {
      console.warn('页面访问审计上报失败');
    });
  }, [pathname, userId]);
  return null;
}
